import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, inject, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-modal-handle-login-errors',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  templateUrl: './modal-handle-login-errors.component.html',
  styleUrl: './modal-handle-login-errors.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModalHandleLoginErrorsComponent {
  @Output() actionButton = new EventEmitter<void>();

  readonly nzModalData = inject(NZ_MODAL_DATA);
  dataModal: any;

  constructor() {}

  ngOnInit() {
    this.dataModal = this.nzModalData.dataModal;
  }

  protected onAction(): void {
    this.dataModal?.actionButton();
  }
}
